import PageContent from '@/components/PageContent';
import React from 'react';
import { PanelGroup } from 'rsuite';
import CheckActivitiesEmptyCityAction from './check-activities-empty-city-action';
import CheckActivitiesEmptyCountryAction from './check-activities-empty-country-action';


const GlobalActionsPage: React.FC = () => {

    return (
        <PageContent>
            <PanelGroup>
                <CheckActivitiesEmptyCityAction/>
                <CheckActivitiesEmptyCountryAction/>
            </PanelGroup>
        </PageContent>
    );
};

export default GlobalActionsPage;
